import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonSize } from '@widgets/eop-button/eop-button.component';
import { ProgressStates } from '@widgets/save-button/save-button.component';

export interface ButtonOption {
  label: string;
  value: string;
  description?: string;
}

@Component({
  selector: 'eop-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrls: ['./dropdown-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DropdownButtonComponent {
  protected readonly ButtonSize = ButtonSize;
  protected readonly ProgressStates = ProgressStates;
  @Input() disabled: boolean;
  @Input() options: ButtonOption[];
  @Input() inProgress: boolean;
  @Input() dataTestId: string = 'dropdown-button';
  @Input() noDefault: boolean = false; // If false, the first option will be used as default
  @Input() defaultIcon: string;
  @Input() defaultLabel: string;
  @Input() buttonSize: ButtonSize = ButtonSize.LARGE;

  @Output() optionSelected: EventEmitter<string> = new EventEmitter();

  dropdownIsOpen: boolean;

  onOptionSelect(option: ButtonOption): void {
    this.inProgress = true;
    this.optionSelected.emit(option.value);
  }

  openDropdown(): void {
    this.dropdownIsOpen = true;
  }

  closeDropdown(): void {
    this.dropdownIsOpen = false;
  }
}
